import { render, staticRenderFns } from "./giftLication.vue?vue&type=template&id=7b6ed3e6"
import script from "./giftLication.vue?vue&type=script&lang=js"
export * from "./giftLication.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports